<div class="produccion-container">
  <div class="header-actions">
    <h1>Producción</h1>
    <div class="header-buttons">
      <button mat-stroked-button color="primary" (click)="exportarPdf()" [disabled]="!lotes.length">
        <mat-icon>picture_as_pdf</mat-icon> Exportar PDF
      </button>
      <button mat-raised-button color="primary" (click)="abrirNuevaProduccion()">
        <mat-icon>add</mat-icon> Nueva Producción
      </button>
    </div>
  </div>

  <!-- Filtros de fecha -->
  <mat-card class="filtros-card">
    <mat-card-content>
      <form [formGroup]="filtroForm" class="filtros-form">
        <mat-form-field appearance="outline">
          <mat-label>Fecha inicio</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Fecha fin</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
        <button mat-flat-button color="primary" (click)="cargarLotes()" [disabled]="isLoading">
          <mat-icon>search</mat-icon> Buscar
        </button>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Tarjetas de resumen -->
  <section class="summary-grid" *ngIf="lotes.length">
    <mat-card class="summary-card">
      <mat-icon mat-card-avatar color="warn">attach_money</mat-icon>
      <div>
        <h4>Gasto Total</h4>
        <span>{{ totalGasto | currency }}</span>
      </div>
    </mat-card>
    <mat-card class="summary-card">
      <mat-icon mat-card-avatar color="primary">inventory_2</mat-icon>
      <div>
        <h4>Total Unidades</h4>
        <span>{{ totalUnidades }}</span>
      </div>
    </mat-card>
    <mat-card class="summary-card">
      <mat-icon mat-card-avatar color="accent">trending_up</mat-icon>
      <div>
        <h4>Ganancia Potencial</h4>
        <span>{{ totalGanancia | currency }}</span>
      </div>
    </mat-card>
    <mat-card class="summary-card">
      <mat-icon mat-card-avatar style="color: #4CAF50">show_chart</mat-icon>
      <div>
        <h4>Margen Bruto</h4>
        <span>{{ (totalGanancia - totalGasto) | currency }}</span>
      </div>
    </mat-card>
  </section>

  <!-- Tabla de lotes -->
  <mat-card class="table-card">
    <mat-card-content>
      <div *ngIf="isLoading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Cargando historial...</p>
      </div>

      <div *ngIf="!isLoading && lotes.length === 0" class="empty-state">
        <mat-icon>precision_manufacturing</mat-icon>
        <h3>No hay lotes registrados</h3>
        <p>Crea una nueva producción para comenzar.</p>
        <button mat-raised-button color="primary" (click)="abrirNuevaProduccion()">
          <mat-icon>add</mat-icon> Nueva Producción
        </button>
      </div>

      <mat-accordion *ngIf="!isLoading && lotes.length > 0">
        <mat-expansion-panel *ngFor="let lote of lotes" class="lote-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="tipo-icon">{{ lote.tipoProduccion === 'impresion_3d' ? 'view_in_ar' : lote.tipoProduccion === 'te' ? 'local_cafe' : 'handyman' }}</mat-icon>
              {{ tipoProduccionLabels[lote.tipoProduccion] || lote.tipoProduccion }}
            </mat-panel-title>
            <mat-panel-description>
              {{ lote.fecha | date:'dd/MM/yyyy' }} — {{ lote.totalUnidades }} unidades — {{ lote.costoTotalMaterial | currency }}
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="lote-detail">
            <div class="lote-stats">
              <div class="stat">
                <span class="stat-label">Costo Material</span>
                <span class="stat-value warn">{{ lote.costoTotalMaterial | currency }}</span>
              </div>
              <div class="stat">
                <span class="stat-label">Unidades</span>
                <span class="stat-value">{{ lote.totalUnidades }}</span>
              </div>
              <div class="stat">
                <span class="stat-label">Ganancia Potencial</span>
                <span class="stat-value accent">{{ lote.gananciaPotencial | currency }}</span>
              </div>
              <div class="stat">
                <span class="stat-label">Margen Bruto</span>
                <span class="stat-value success">{{ lote.margenBruto | currency }}</span>
              </div>
            </div>

            <div *ngIf="lote.observaciones" class="lote-obs">
              <mat-icon>notes</mat-icon>
              <span>{{ lote.observaciones }}</span>
            </div>

            <h4>Productos del lote</h4>
            <table mat-table [dataSource]="lote.items" class="items-table">
              <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef>Producto</th>
                <td mat-cell *matCellDef="let item">{{ item.producto?.nombre }}</td>
              </ng-container>
              <ng-container matColumnDef="cantidad">
                <th mat-header-cell *matHeaderCellDef>Unidades</th>
                <td mat-cell *matCellDef="let item">
                  {{ lote.tipoProduccion === 'impresion_3d' ? (item.unidades + ' uds') :
                     lote.tipoProduccion === 'te' ? (item.cantidad + ' bolsas × ' + item.gramos + 'g') :
                     (item.unidades + ' uds') }}
                </td>
              </ng-container>
              <ng-container matColumnDef="precioVenta">
                <th mat-header-cell *matHeaderCellDef>Precio Venta</th>
                <td mat-cell *matCellDef="let item">{{ item.precioVenta | currency }}</td>
              </ng-container>
              <ng-container matColumnDef="costoUnitario">
                <th mat-header-cell *matHeaderCellDef>Costo Unitario</th>
                <td mat-cell *matCellDef="let item">{{ item.costoUnitario | currency }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['nombre','cantidad','precioVenta','costoUnitario']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['nombre','cantidad','precioVenta','costoUnitario'];"></tr>
            </table>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </mat-card>
</div>
